import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-white py-14 sm:py-16" data-id="element-173" data-mp="3gk4bi6yjt892">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-174" data-mp="3lio1qjk6d678">
        <SectionTag icon="💰" data-id="element-175" data-mp="3pjhq1e1j4n0n">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-176" data-mp="3phwsdfjx4nyk">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-gris-texto sm:text-lg" data-id="element-177" data-mp="3cjb20fkgpau">Acceso inmediato y garantía total de 14 días.</p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-6 sm:px-8" data-id="element-178" data-mp="2064g99ane6s5">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-2xl border-2 border-naranja bg-bg-secondary p-6 shadow-leve sm:p-7" data-id="element-179" data-mp="2534ljhzob5i7">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-gris-muted" data-id="element-180" data-mp="11knm3wkpop9t">
            🏐 Balonmano Pro 360: La Pizarra del Entrenador
          </p>
          <p className="mt-1.5 text-xs text-gris-muted" data-id="element-181" data-mp="xhikrxcdatmr">6 tomos + 5 bonos, listos para llevar a la pista.</p>

          <div className="mt-4 space-y-1.5" data-id="element-182" data-mp="1pahykd14cbtj">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-gris-claro py-1.5 text-sm" data-id="element-183" data-mp="1p8or4violnkh">
                <span className="text-gris-texto" data-id="element-184" data-mp="1g9jszqb17w8u">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-185" data-mp="9uskb0fo3749">
                  <span className="text-gris-texto" data-id="element-186" data-mp="4uxxp92xd3p0">{row.value}</span>
                  <CheckIcon size={14} className="text-verde" data-id="element-187" data-mp="4x0v4e6epz3r" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-marino" data-id="element-188" data-mp="bao9uemmx3rw">
              <span data-id="element-189" data-mp="3tgt4f8ud64tk">VALOR TOTAL</span>
              <span className="text-rojo line-through" data-id="element-190" data-mp="3tfrjmcnjq3yn">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-gris-muted" data-id="element-191" data-mp="1bfmw5q6spf1">Precio hoy (84% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-marino sm:text-6xl" data-id="element-192" data-mp="3jp59gxylm5nc">19€</p>
          <span className="mt-2 inline-block rounded-full bg-naranja-light px-3 py-1 text-sm font-semibold text-black" data-id="element-193" data-mp="3oihtsvw8vqaa">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          <div className="mt-6" data-id="element-194" data-mp="3eqvaec9r6kwg">
            <PrimaryButton href={CHECKOUT_URL} fullWidth data-id="element-195" data-mp="3erwqiv5mlxl1">
              Quiero Balonmano Pro 360 por 19€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-gris-muted" data-id="element-196" data-mp="35rgolq4j6yia">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-197" data-mp="2m79eltgm5y1s">
                <item.icon size={12} data-id="element-198" data-mp="2h7djyktt3iyw" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}